document.addEventListener('DOMContentLoaded', () => {
  const originalFetch = window.fetch.bind(window);
  const isAddToCartRequest = (input) => {
    const url = typeof input === 'string' ? input : input?.url;
    return typeof url === 'string' && url.includes('/cart/add');
  };

  window.fetch = async (input, init = {}) => {
    if (isAddToCartRequest(input)) {
      const isSubscriptionProduct =
        window?.Rebuy?.Cart?.cart?.items[0]?.selling_plan_allocation?.selling_plan?.name?.includes('subscription');
      if (typeof init.body === 'string' && (init.body.startsWith('{') || init.body.startsWith('['))) {
        let body;
        try {
          body = JSON.parse(init.body);
        } catch (e) {
          // body is not valid JSON, skip mutation
        }
        if (body && isSubscriptionProduct && body?.properties?._source === 'Rebuy') {
          const selectedFreq = (
            window?.Rebuy?.Cart?.cart?.items[0]?.selling_plan_allocation?.selling_plan?.name || ''
          ).match(/\d+/)?.[0];
          const widgetId = document.body.classList.contains('cart-template')
            ? document.querySelector('.promotional-blocks [data-rebuy-id]')?.dataset?.rebuyId
            : window.Rebuy?.SmartCart?.getAllCrossSellWidgetIds()?.[0]?.toString();
          const sellingPlanId = window.Rebuy.widgets
            ?.find((widget) => widget.id === widgetId)
            ?.data?.products?.find((product) => product.selected_variant?.id === body.id)
            ?.selected_variant?.selling_plans?.find(
              (sellingPlan) => sellingPlan.name.match(/\d+/)?.[0] === selectedFreq,
            )?.id;
          if (sellingPlanId) {
            body.selling_plan = sellingPlanId;
            init.body = JSON.stringify(body);
          }
        }
      }
    }
    return originalFetch(input, init);
  };
});
